webpackJsonp([70144966829960],{

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/me3.6eddedcf.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _me = __webpack_require__(491);
	
	var _me2 = _interopRequireDefault(_me);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 col-md-4 col-sm-6' },
	                _react2.default.createElement('img', { className: 'profile-pic', src: _me2.default }),
	                _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7 col-md-8 col-sm-5 about' },
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'contact-box' },
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:sandra.harrison@boostedhuman.com' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'inline-header' },
	                            'Contact Me:'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'sandra.harrison@boostedhuman.com'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://twitter.com/SanniHarrison', className: 'twitter-follow-button', 'data-show-count': 'false' },
	                        'Follow'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('script', { src: '//platform.linkedin.com/in.js', type: 'text/javascript' }),
	                    _react2.default.createElement('script', { type: 'IN/MemberProfile', 'data-id': 'https://www.linkedin.com/pub/sandra-harrison/97/589/362', 'data-format': 'click', 'data-text': 'Sandra Harrison' })
	                )
	            )
	        )
	    );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-f0fcef4ea53db51c60ff.js